import { z } from "zod/v4";
import { BusinessDetails } from "./_common";

export const Role = z.enum(["CPO", "EMSP", "NAP", "NSP", "OTHER", "SCSP"]);

export const CredentialsRole = z.object({
  role: Role,
  business_details: BusinessDetails,
  party_id: z.string().length(3),
  country_code: z.string().length(2),
});

export const OcpiCredentials = z.object({
  token: z.string().max(64),
  url: z.url(),
  hub_party_id: z.string().length(5).nullish(),
  roles: z.array(CredentialsRole).nonempty(),
});
